import { render, staticRenderFns } from "./FullLoader.vue?vue&type=template&id=4a5c337e&scoped=true"
import script from "./FullLoader.vue?vue&type=script&lang=js"
export * from "./FullLoader.vue?vue&type=script&lang=js"
import style0 from "./FullLoader.vue?vue&type=style&index=0&id=4a5c337e&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a5c337e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src117016002/src/console/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4a5c337e')) {
      api.createRecord('4a5c337e', component.options)
    } else {
      api.reload('4a5c337e', component.options)
    }
    module.hot.accept("./FullLoader.vue?vue&type=template&id=4a5c337e&scoped=true", function () {
      api.rerender('4a5c337e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/MainContent/FullLoader.vue"
export default component.exports